import info from '../assets/images/info_50px.png';
import contact from '../assets/images/ringer_volume_50px.png';
import photo from '../assets/images/camera_50px.png';
import publication from '../assets/images/edit_property_50px.png';

const tabs = [
  { index: 0, name: 'Information', icon: info },
  { index: 1, name: 'Contact', icon: contact },
  { index: 2, name: 'Photo', icon: photo },
  { index: 3, name: 'Publication', icon: publication },
];

export default tabs;
